import React, { FC } from "react";
import styled from "styled-components/macro";
import Module from "shared/lib/interfaces/Module";
import ModuleSection from "shared/lib/interfaces/ModuleSection";
import SlidePage, { SlidePageProgress, SlidePageProps } from "../../SlidePage";

interface Props {
  module: Pick<Module, "icon" | "name">;
  section: Pick<ModuleSection, "name">;
  progress: SlidePageProgress;
  onNext: SlidePageProps["onNext"];
  onBack: SlidePageProps["onBack"];
}

const ManagingStressWelcomeSlide: FC<Props> = (props) => {
  const { module, section, ...rest } = props;

  return (
    <SlidePage {...rest} title={module.name}>
      <section>
        <h3>MANAGING STRESS</h3>
        <p>
          Let’s face it, stress is part of life. But when you get too stressed,
          it becomes hard to cope with your everyday jobs.
        </p>
      </section>
    </SlidePage>
  );
};

export default styled(ManagingStressWelcomeSlide)``;
